/* APC direct signup and preferences without Klaviyo onsite identification. */
(() => {
  const dialog = document.getElementById('gap-capture-preview');
  if (!dialog) return;
  const sources = { footer: 'GAP AU Footer', 'exit-intent': 'GAP AU - Exit Intent', 'engaged-browse': 'GAP AU - Engaged Browse' };
  const form = dialog.querySelector('[data-capture-form]');
  const preferences = dialog.querySelector('[data-capture-preferences]');
  const success = dialog.querySelector('[data-capture-success]');
  const title = dialog.querySelector('h2');
  const intro = dialog.querySelector('[data-capture-intro]');
  const status = dialog.querySelector('[data-capture-status]');
  const preferenceStatus = dialog.querySelector('[data-preferences-status]');
  let source = 'footer', subscribedEmail = '', busy = false, opened = false;
  const accepted = new Set();
  const suppressionKey = 'gap-capture-hide-until';
  const subscriberKey = 'gap-capture-subscribed';
  let subscribed = dialog.dataset.subscribedCustomer === 'true';
  let hideUntil = 0;
  const isSuppressed = () => {
    if (subscribed || hideUntil > Date.now()) return true;
    try {
      return localStorage.getItem(subscriberKey) === '1'
        || Number(localStorage.getItem(suppressionKey)) > Date.now();
    } catch { return false; }
  };
  const suppressFor30Days = () => {
    hideUntil = Date.now() + 30 * 86400000;
    try { localStorage.setItem(suppressionKey, String(hideUntil)); }
    catch { /* Retain suppression on this page when browser storage is unavailable. */ }
  };
  const rememberSubscriber = () => {
    subscribed = true;
    // Save only a suppression flag, never the subscriber's email.
    try { localStorage.setItem(subscriberKey, '1'); }
    catch { /* Retain subscriber suppression on this page. */ }
  };
  const show = step => {
    form.hidden = step !== 'email'; intro.hidden = step !== 'email';
    preferences.hidden = step !== 'preferences'; success.hidden = step !== 'success';
    title.textContent = step === 'email' ? 'Stay in the loop.' : step === 'preferences' ? 'Make it your Gap.' : 'You’re on the list.';
    if (!dialog.open) dialog.showModal();
    title.setAttribute('tabindex', '-1'); title.focus();
  };
  const post = async (resource, data) => {
    const response = await fetch('https://a.klaviyo.com/client/' + resource + '/?company_id=UvhePE', {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify({ data }), signal: AbortSignal.timeout(15000)
    });
    if (!response.ok) throw new Error('request_failed');
  };
  const subscribe = async (email, nextSource, button) => {
    if (busy) return;
    busy = true; source = nextSource; button.disabled = true; status.textContent = '';
    try {
      const key = source + ':' + email.toLowerCase();
      if (!accepted.has(key)) {
        await post('subscriptions', { type: 'subscription', attributes: {
          custom_source: sources[source], profile: { data: { type: 'profile', attributes: {
            email, properties: { gap_capture_strategy: source, gap_capture_theme: 'APC Launch' },
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        }, relationships: { list: { data: { type: 'list', id: 'SV2vk9' } } } });
        accepted.add(key);
      }
      subscribedEmail = email; rememberSubscriber(); preferences.reset(); preferenceStatus.textContent = ''; show('preferences');
    } catch (error) {
      form.elements.email.value = email;
      status.textContent = 'We could not confirm your signup. Please check your connection and try again.';
      show('email');
    } finally { busy = false; button.disabled = false; }
  };
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (form.reportValidity()) return subscribe(form.elements.email.value.trim(), source, form.querySelector('[type=submit]'));
  });
  preferences.addEventListener('submit', async event => {
    event.preventDefault(); if (busy || !subscribedEmail) return;
    busy = true; const button = preferences.querySelector('[type=submit]'); button.disabled = true;
    dialog.querySelector('[data-capture-skip]').disabled = true; preferenceStatus.textContent = '';
    try {
      const interests = Array.from(preferences.querySelectorAll('input:checked')).map(input => input.value);
      // Only explicit email interests; no cookies, tracking event or re-subscription.
      await post('profiles', { type: 'profile', attributes: { email: subscribedEmail, properties: { 'Email Interests': interests } } });
      show('success');
    } catch (error) {
      preferenceStatus.textContent = 'Your email signup was accepted, but preferences could not be saved. Try again or select Not Now.';
    } finally { busy = false; button.disabled = false; dialog.querySelector('[data-capture-skip]').disabled = false; }
  });
  dialog.querySelector('[data-capture-skip]').addEventListener('click', () => { if (!busy) show('success'); });
  for (const selector of ['[data-capture-close]', '[data-capture-done]']) dialog.querySelector(selector).addEventListener('click', () => {
    suppressFor30Days();
    dialog.close();
  });
  dialog.addEventListener('cancel', () => suppressFor30Days());
  document.querySelectorAll('[data-klaviyo-footer-trigger]').forEach(footer => {
    footer.addEventListener('submit', event => {
      event.preventDefault();
      if (footer.reportValidity()) return subscribe(footer.querySelector('input[type=email]').value.trim(), 'footer', footer.querySelector('[type=submit]'));
    });
  });
  const open = nextSource => {
    if (busy || opened || dialog.open || isSuppressed()) return;
    opened = true;
    source = nextSource;
    status.textContent = '';
    show('email');
  };
  const path = location.pathname;
  // GAP-wide browsing pages, including home and editorial pages; never interrupt checkout or account tasks.
  if (/^\/(cart|checkout|checkouts|account|search|policies)(\/|$)/.test(path) || isSuppressed()) return;

  // Only show acquisition prompts to a visitor with an empty cart.
  const initialCart = window.theme?.cart?.initialData;
  const cartReady = initialCart
    ? Promise.resolve(initialCart)
    : fetch('/cart.js', { credentials: 'same-origin' }).then(response => {
        if (!response.ok) throw new Error('cart_unavailable');
        return response.json();
      });
  cartReady
    .then(cart => {
      if (cart.item_count !== 0) return;
      const start = Date.now();
      const desktop = matchMedia('(hover: hover) and (pointer: fine)').matches;
      let deepestScroll = 0;
      let previousScroll = scrollY;
      document.addEventListener('mouseout', event => {
        if (desktop && !event.relatedTarget && event.clientY <= 0 && Date.now() - start >= 20000) open('exit-intent');
      });
      const checkScroll = () => {
        const height = document.documentElement.scrollHeight - innerHeight;
        if (height <= 0) return;
        const depth = scrollY / height;
        deepestScroll = Math.max(deepestScroll, depth);
        const elapsed = Date.now() - start;
        if (!desktop && elapsed >= 20000 && deepestScroll >= .5 && depth <= .15 && scrollY < previousScroll) {
          open('exit-intent');
        } else if (elapsed >= 30000 && depth >= .5) {
          open('engaged-browse');
        }
        previousScroll = scrollY;
      };
      addEventListener('scroll', checkScroll, { passive: true });
      setTimeout(checkScroll, 30000);
    })
    .catch(() => { /* Unknown cart state: do not show an acquisition prompt. */ });
})();
